import React from 'react';
import classNames from 'classnames';
import { MediafilePosterSkeleton } from '../MediafilePosterSkeleton/MediafilePosterSkeleton';
import type { MediafileItemSkeletonProps } from '../MediafileItem/types';
import styles from './index.module.scss';

export const MediafileItemSkeleton: React.FC<MediafileItemSkeletonProps> = ({ leading, textRows = 1, className }) => (
  <div
    className={classNames(styles.container, className)}
    aria-hidden="true">
    {leading && <div className={classNames(styles.leading, leading === 'checkbox' && styles.checkbox)} />}
    <div className={styles.body}>
      <MediafilePosterSkeleton />
      <div className={styles.text}>
        <div className={styles.title} />
        {textRows === 2 && <div className={styles.metadata} />}
      </div>
    </div>
  </div>
);
